module.exports = __webpack_public_path__ + "static/media/demo1.84ab4eab.png";